import axios from './axiosConfig';

const API_URL = process.env.NODE_ENV === 'production'
  ? "https://api.demo1.raborisk.ai"
  : "http://localhost:3000";

const PYTHON_API_URL = process.env.NODE_ENV === 'production'

  ? "https://api.ai.raborisk.ai"
  : "https://api.ai.raborisk.ai";

export const TOGGLE_CHATBOT = 'TOGGLE_CHATBOT';
export const SHOW_CHATBOT = 'SHOW_CHATBOT';
export const HIDE_CHATBOT = 'HIDE_CHATBOT';


export const toggleChatbot = () => ({ type: TOGGLE_CHATBOT });
export const showChatbot = () => ({ type: SHOW_CHATBOT });
export const hideChatbot = () => ({ type: HIDE_CHATBOT });

export const shareChat = async (chat_id, user_id) => {
  const res = await axios.post(
    `${API_URL}/api/chat/share`,
    { chat_id, user_id },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    }
  );

  return res.data;
};

export const sendChatMessageNode = (message, chatId = null) => {
  return (dispatch) => {
    dispatch({ type: "CHATBOT_MESSAGE_SEND_START" });

    let finalChatId = chatId;

    axios
      .post(API_URL + "/api/chat/add_chat", {
        title: message?.trim()?.slice(0, 60) || "New Chat",
      })
      .then(({ data }) => {
        if (!finalChatId) finalChatId = data.chat_id;

        return axios.post(API_URL + "/api/chat/add_chat_message", {
          chatId: finalChatId,
          sender: "user",
          senderName: "You",
          messageText: message,
        });
      })
      .then(() => {
        dispatch({ type: "CHATBOT_MESSAGE_SEND_START_BOT" });

        return axios.post(API_URL + "/api/ai/chat", { message });
      })
      .then(({ data }) => {
        const botReply = data.reply || "";

        dispatch({
          type: "CHATBOT_MESSAGE_PARTIAL",
          payload: botReply,
        });

        dispatch({
          type: "CHATBOT_MESSAGE_SEND_SUCCESS",
          payload: botReply,
        });

        return axios.post(API_URL + "/api/chat/add_chat_message", {
          chatId: finalChatId,
          sender: "bot",
          senderName: "Rabo",
          messageText: botReply,
        });
      })
      .catch((error) => {
        console.error("Chatbot message error:", error);

        dispatch({
          type: "CHATBOT_MESSAGE_SEND_FAILURE",
          payload: error.message,
        });
      });
  };
};

export const addChat = (title = "New Chat") => {
  return (dispatch) => {
    const token = localStorage.getItem("token");

    return axios
      .post(
        API_URL + "/api/chat/add_chat",
        { title },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(({ data }) => {
        dispatch({
          type: "CHATBOT_ADD_CHAT",
          payload: {
            chat_id: data.chat_id,
            title,
          },
        });

        return data;
      })
      .catch((error) => {
        console.error("Error creating chat:", error);
        throw error;
      });
  };
};

export const getChats = () => {
  return (dispatch) => {
    const token = localStorage.getItem("token");

    return axios
      .get(API_URL + "/api/chat/get_chats", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(({ data }) => {
        dispatch({
          type: "CHATBOT_SET_CHATS",
          payload: data,
        });
        return data;
      })
      .catch((error) => {
        console.error("Error fetching chats:", error);
        throw error;
      });
  };
};

export const renameChat = (chatId, title) => {
  return (dispatch) => {
    const token = localStorage.getItem("token");

    return axios
      .post(
        API_URL + "/api/chat/rename_chat",
        { chatId, title },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(({ data }) => {
        dispatch({
          type: "CHATBOT_RENAME_CHAT",
          payload: data,
        });
        return data;
      })
      .catch((error) => {
        console.error("Error renaming chat:", error);
        throw error;
      });
  };
};


export const getChatMessages = (chatId) => {
  return (dispatch) => {
    const token = localStorage.getItem("token");

    return axios
      .get(API_URL + "/api/chat/get_chat_messages", {
        params: { chatId },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(({ data }) => {
        dispatch({
          type: "CHATBOT_SET_MESSAGES",
          payload: data,
        });
        return data;
      })
      .catch((error) => {
        console.error("Error fetching chat messages:", error);
        throw error;
      });
  };
};


export const resetActiveChat = () => {
  return (dispatch) => {
    dispatch({
      type: "RESET_ACTIVE_CHAT",
    });
  }
}

export const setActiveChat = (chatID) => {
  ////console.log("setting_i ", chatID)
  return (dispatch) => {
    dispatch({
      type: "SET_ACTIVE_CHAT",
      payload: chatID
    });
  }
}

export const deleteChat = (chatId) => {
  return (dispatch) => {
    const token = localStorage.getItem("token");

    return axios
      .post(
        API_URL + "/api/chat/delete_chat",
        { chatId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(({ data }) => {
        dispatch({
          type: "CHATBOT_DELETE_CHAT",
          payload: data.chat_id,
        });
        return data;
      })
      .catch((error) => {
        console.error("Error deleting chat:", error);
        throw error;
      });
  };
};

export const sendChatMessage = (message, chatId = null) => {
  return async (dispatch) => {
    dispatch({ type: "CHATBOT_MESSAGE_SEND_START" });

    try {
      let finalChatId = chatId;

      // 1) create chat if needed
      if (!finalChatId) {
        const { data } = await axios.post(API_URL + "/api/chat/add_chat", {
          title: message?.trim()?.slice(0, 60) || "New Chat",
        });

        finalChatId = data.chat_id;
      }

      // 2) save user message
      await axios.post(API_URL + "/api/chat/add_chat_message", {
        chatId: finalChatId,
        sender: "user",
        senderName: "You",
        messageText: message,
      });

      // 3) start bot row in UI
      dispatch({ type: "CHATBOT_MESSAGE_SEND_START_BOT" });

      const res = await fetch(PYTHON_API_URL + "/chat", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ message }),
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const reader = res.body.getReader();
      const decoder = new TextDecoder();

      let full = "";

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        full += chunk;

        dispatch({
          type: "CHATBOT_MESSAGE_PARTIAL",
          payload: chunk,
        });
      }

      const finalReply = full.trim();

      dispatch({
        type: "CHATBOT_MESSAGE_SEND_SUCCESS",
        payload: finalReply,
      });

      // 4) save bot message
      await axios.post(API_URL + "/api/chat/add_chat_message", {
        chatId: finalChatId,
        sender: "bot",
        senderName: "Rabo",
        messageText: finalReply,
      });

      return {
        reply: finalReply,
        chatId: finalChatId,
      };

    } catch (error) {
      console.error("Chat error:", error);

      dispatch({
        type: "CHATBOT_MESSAGE_SEND_FAILURE",
        payload: error.message,
      });
    }
  };
};


